import { useEffect, useState } from 'react'

const useStickyNavigationBar = (navRef: React.RefObject<HTMLDivElement>) => {
    const [isSticky, setIsSticky] = useState(false)

    useEffect(() => {
        if (!navRef.current) return

        const navOffset = navRef.current.offsetTop
        let isCurrentlySticky = false

        const handleScroll = () => {
            if (!navRef.current) return

            const scrollPosition = window.scrollY

            if (scrollPosition > navOffset) {
                if (!isCurrentlySticky) {
                    setIsSticky(true)
                    isCurrentlySticky = true
                }
            } else {
                if (isCurrentlySticky) {
                    setIsSticky(false)
                    isCurrentlySticky = false
                }
            }
        }

        window.addEventListener('scroll', handleScroll, { passive: true })

        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    return isSticky
}

export default useStickyNavigationBar
